import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
    footer: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        backgroundColor: '#bcbcff'
    }
}))
